var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import "reflect-metadata";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
var isAphaNumericWithSpace = require("../../../lib/validate").isAphaNumericWithSpace;
import ExtendModal from "@/components/ExtendModal.vue";
import InputV2 from "@/components/inputv2.vue";
import ButtonV2 from "@/components/button.vue";
import ReserveAccountFilter from "./ReserveAccountFilter.vue";
import { namespace } from "vuex-class";
import { computed } from "@vue/composition-api";
import moment from "moment";
import Table from "@/components/table.vue";
import Loader from "@/components/loader.vue";
import Tab from "@/components/tab.vue";
import NotFound from "@/components/notfound.vue";
import StatusIndicator from "@/components/status-indicator.vue";
import Pagination from "@/components/pagination.vue";
import { objectToQuery } from "../../../lib/objectToQuery";
import EmptyState from "@/components/empty-state.vue";
var Store = namespace("ts");
var Account = /** @class */ (function (_super) {
    __extends(Account, _super);
    function Account() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openFilter = false;
        _this.showExportOptions = false;
        _this.state = {};
        _this.payoutLength = 0;
        return _this;
    }
    Account.prototype.mounted = function () {
        this.initState();
        this.fetchTable();
        this.fetchReservedAccountDetails(this.$route.params.id);
    };
    Account.prototype.findBank = function (code) {
        var bankNames = this.$store.getters.getBankList;
        if (bankNames) {
            var bank = Object.values(bankNames).find(function (bank) { return bank.code == code; });
            return bank ? bank.name : "";
        }
    };
    Account.prototype.initState = function () {
        var id = this.$route.params.id;
        this.state = {
            tabs: [
                {
                    url: "/dashboard/accounts/reserved/" + id,
                    name: "Recent Payouts",
                },
                {
                    url: "/dashboard/accounts/reserved/" + id + "/funding",
                    name: "Funding History",
                },
            ],
            isPayOuts: true,
            modalType: "",
            showModalContent: false,
            closeModal: true,
            showExport: true,
            showFliter: true,
            filter: {
                bank_code: "",
            },
            dateRange: { endDate: moment(), startDate: moment() },
        };
    };
    Account.prototype.gotoPayout = function (item) {
        this.$router.push({
            name: "view-payout-single-details",
            params: { id: item.merchant_id || item.id, reference: item.payout_reference },
        });
    };
    Account.prototype.gotoTransaction = function (item) {
        this.$router.push({
            name: "transaction-details",
            params: { id: item.reference },
        });
    };
    Account.prototype.handleExportDownload = function (type) {
        var query = objectToQuery({
            account_id: this.$route.params.id,
            query: this.$route.query,
            funding: !this.state.isPayOuts,
        });
        var url = this.state.isPayOuts ? "dashboard/admin/payouts/list".concat((query)) : "dashboard/admin/reserved_vnuban/funding/".concat(this.$route.params.id).concat((query));
        this.$store.dispatch("download", {
            downloadType: type,
            url: url,
            key: this.state.isPayOuts ? "payout_transactions" : 'funding_history',
            filter: this.state.filter,
            fileName: this.state.isPayOuts ? "payouts" : 'funding_history',
        });
        this.showExportOptions = !this.showExportOptions;
    };
    Account.prototype.clearFilter = function () {
        this.$store.dispatch("getPayOuts", __assign({}, this.$route.query));
    };
    Account.prototype.fetchTable = function () {
        var _a = this.$route, id = _a.params.id, name = _a.name;
        this.state.isPayOuts = (name === null || name === void 0 ? void 0 : name.toLowerCase()) !== "funding";
        this.state.page = name === null || name === void 0 ? void 0 : name.toLowerCase();
        this.fetchReservedAccountPayout({
            id: id,
            query: this.$route.query,
            funding: !this.state.isPayOuts,
        });
    };
    Object.defineProperty(Account.prototype, "contents", {
        get: function () {
            var _this = this;
            var data = computed(function () { return _this.$store.getters.getPayOutDashboard; });
            return data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Account.prototype, "getters", {
        get: function () {
            return this.$store.getters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Account.prototype, "commit", {
        get: function () {
            return this.$store.commit;
        },
        enumerable: false,
        configurable: true
    });
    Account.prototype.toggleFilter = function () {
        this.openFilter = !this.openFilter;
    };
    __decorate([
        Prop()
    ], Account.prototype, "toggle", void 0);
    __decorate([
        Store.Action
    ], Account.prototype, "fetchReservedAccountDetails", void 0);
    __decorate([
        Store.Action
    ], Account.prototype, "fetchReservedAccountPayout", void 0);
    __decorate([
        Store.Getter
    ], Account.prototype, "getReservedAccountsDetails", void 0);
    __decorate([
        Store.Getter
    ], Account.prototype, "getReservedPayouts", void 0);
    __decorate([
        Watch("$route")
    ], Account.prototype, "fetchTable", null);
    Account = __decorate([
        Component({
            name: "ViewReservedAccountDetails",
            components: {
                EmptyState: EmptyState,
                ExtendModal: ExtendModal,
                InputV2: InputV2,
                ButtonV2: ButtonV2,
                ReserveAccountFilter: ReserveAccountFilter,
                Table: Table,
                Tab: Tab,
                Loader: Loader,
                StatusIndicator: StatusIndicator,
                NotFound: NotFound,
                Pagination: Pagination
            },
        })
    ], Account);
    return Account;
}(Vue));
export default Account;
